import {
  DocumentServicesObject,
  RouterPrefixValidationResult,
} from '@wix/document-services-types';

import { InvalidPrefixReason } from '../constants';

const ILLEGAL_CHARACTERS_PATTERN = /[^\p{L}\p{M}0-9-]/gu;

export const sanitizeRouterPrefix = (prefix: string): string =>
  prefix.replace(ILLEGAL_CHARACTERS_PATTERN, '');

export const isDuplicatePrefixError = (errorCode: number | string): boolean => {
  const code = Number(errorCode);
  return (
    code === InvalidPrefixReason.PREFIX_IS_DUPLICATE_OF_URI_SEO ||
    code === InvalidPrefixReason.PREFIX_IS_IN_USE_BY_ANOTHER_APPLICATION
  );
};

export const isInvalidCharError = (errorCode: number | string): boolean =>
  Number(errorCode) === InvalidPrefixReason.PREFIX_CONTAINS_INVALID_CHARACTERS;

export function validateRouterPrefix(
  documentServices: DocumentServicesObject,
  appDefinitionId: string,
  prefix?: string,
): Omit<RouterPrefixValidationResult, 'message'> {
  const { errorCode, valid } = documentServices.routers.isValidPrefixByAppDefId(
    appDefinitionId,
    prefix,
  );

  return {
    errorCode,
    valid,
  };
}
